import { Injectable, OnDestroy, OnInit } from '@angular/core';

import { ClarityConfig } from '../../config/clarity.config';
import { LoggerService } from '../logger.service';
import { Store } from '@ngrx/store';
import { State } from '../../store';
import { combineLatest, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import * as myCoachActions from '../../store/session/actions/my-coach.actions';
import { getInappCoaching } from '../../store/session/selectors/my-coach.selectors';
import { getIsCoachingTabEnabled } from '../../store/normalized/selectors/user.selectors';

@Injectable({providedIn: 'root'})
export class MyCoachService implements OnDestroy {

  public SERVICE_NAME = 'my-coach';

  public inappCoaching$ = this.store.select(getInappCoaching);
  public coachingTabEnabled$ = this.store.select(getIsCoachingTabEnabled);
  private inappCoachingSubscription: Subscription;

  public typingCoach: Subject<any> = new Subject<any>();
  public typingCoach$: Observable<any> = this.typingCoach.asObservable();

  public coachOnline: ReplaySubject<any> = new ReplaySubject<any>(1);
  public coachOnline$: Observable<any> = this.coachOnline.asObservable();

  private readonly coachOnlineHideDelay: number = 60000;
  private hideCoachOnlineMessageTimeout;

  constructor(
    private config: ClarityConfig,
    private logger: LoggerService,
    private store: Store<State>
  ) {

  }

  public initialize(): Promise<any> {
    this.inappCoachingSubscription = combineLatest([
      this.inappCoaching$,
      this.coachingTabEnabled$
    ]).subscribe(([inappCoaching, coachingTabEnabled]) => {
      if (
        this.config.isERN() && inappCoaching ||
        coachingTabEnabled ||
        this.config.programDPPorWL()
      ) {
        this.store.dispatch(new myCoachActions.LoadUnreadMessagesCount());
      }
    });

    return Promise.resolve();
  }

  ngOnDestroy() {
    this.inappCoachingSubscription && this.inappCoachingSubscription.unsubscribe();
  }

  onCoachOnlineWsMessage(status) {
    this.coachOnline.next(status);
    if (!status) {
      return;
    }
    if (this.hideCoachOnlineMessageTimeout) {
      clearTimeout(this.hideCoachOnlineMessageTimeout);
    }
    this.hideCoachOnlineMessageTimeout = setTimeout(() => {
      this.coachOnline.next(null);
      this.hideCoachOnlineMessageTimeout = null;
    }, this.coachOnlineHideDelay);
  }
}
